<template>
  <div class="homeNightModule" v-if="moduleData">
    <div class="tabContent">
      <div class="inner">
        <div class="title">晚间PK场</div>
        <div class="pkData">
          <ul class="pkDataCount">
            <li>{{ moduleData.evening_pk_num }}</li>
            <li>{{ moduleData.evening_pk_count }}</li>
          </ul>
          <ul class="pkDataName">
            <li>PK人数</li>
            <li>PK局数</li>
          </ul>
        </div>
        <div class="details" v-if="isToday">
          <span
            v-if="
              moduleData.evening_pk_num != 0 && moduleData.evening_pk_count != 0
            "
            @click="toDetailsToday"
            >详情></span
          >
        </div>
        <!-- <router-link>详情> </router-link> -->
        <div class="details" v-if="!isToday">
          <span
            v-if="
              moduleData.evening_pk_num != 0 && moduleData.evening_pk_count != 0
            "
            @click="toDetailsYes"
            >详情></span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "homeNightModule",
  components: {},
  computed: {},
  props: {
    // pkParams: {
    //   type: Object,
    //   default: null,
    // },
    moduleData: {
      type: Object,
      default: null,
    },
    isToday: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  watch: {},
  methods: {
    toDetailsToday() {
      // this.$router.push("/winterGame/details");
      this.$router.push({ name: "details", query: { flag: "today" } });
    },
    toDetailsYes() {
      // this.$router.push("/winterGame/details");
      this.$router.push({ name: "details", query: { flag: "yesToday" } });
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.tabContent {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #68707d;
  padding: 2px;
  border-radius: 10px;
  text-align: center;
  background-image: linear-gradient(#eeb057, #eed890);
  .inner {
    margin: 12px;
    background: #ffffff;
    border-radius: 10px;
    .title {
      font-size: 28px;
      padding-top: 36px;
    }
    .pkData {
      ul {
        width: 100%;
        display: flex;
        list-style: none;
        justify-content: space-evenly;
        align-items: center;
        height: 100px;
        position: relative;
        &::after {
          content: "";
          position: absolute;
          left: 50%; //居中
          transform: translateX(-50%);
          bottom: 0;
          width: 80%;
          height: 1px;
          background-color: #dee5f0;
        }
        &:first-child {
          &::after {
            height: 1px;
          }
        }
        &:last-child {
          &::after {
            height: 0;
          }
        }
      }
      .pkDataCount {
        font-size: 48px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #323232;
      }
      .pkDataName {
        font-size: 28px;
        margin-bottom: -20px;
      }
    }
    .details {
      display: flex;
      justify-content: flex-end;
      padding: 0 30px 30px 0;
      color: #7f5631;
      & span {
        position: relative;
        z-index: 11;
        width: 100px;
        height: 45px;
        display: inline-block;
        line-height: 45px;
      }
    }
  }
}
</style>
